import { copyTextToClipboard } from 'utils/utils';
import styles from './DebugFab.module.css';

export const DebugCopyButton: React.FC<DebugCopyButtonProps> = ({ text }) => {
    const handleCopy = async () => {
        try {
            await copyTextToClipboard(text);
            shopify.toast.show('Copied to clipboard!');
        } catch {
            shopify.toast.show('Failed to copy to clipboard!', { isError: true });
        }
    };

    return (
        <button type="button" className={styles.copyButton} onClick={handleCopy} disabled={!text} title="Copy">
            <s-icon type="clipboard"></s-icon>
        </button>
    );
};

interface DebugCopyButtonProps {
    text: string | null;
}
